export default __webpack_public_path__ + "static/social-enterprise-logo-only-711950feb2f7fa0d83e16643a11f6c57.svg";